import { MARKET_PLACE } from '@sellsen/contants';
import { Space, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
const { Title } = Typography;
const { CheckableTag } = Tag;

const ALLOWED_REGIONS = [
  'Europe',
  'Americas',
  'Middle East',
  'Asia-Pacific',
  'Oceania',
];
export const getCountriesForProductSearch = () => {
  return MARKET_PLACE.filter(
    (marketPlace) =>
      marketPlace.name !== 'UNITED_STATES' &&
      marketPlace.name !== 'BRAZIL' &&
      marketPlace.name !== 'EGYPT' &&
      marketPlace.name !== 'INDIA' &&
      marketPlace.name !== 'SINGAPORE'
  );
};

export const StoreFrontMarketCountrySelection = ({
  onChange,
  value = [],
}: {
  onChange?: (values: string[]) => void;
  value?: string[];
}) => {
  const { t } = useTranslation();

  const filteredCountries = getCountriesForProductSearch();

  const groupedCountries = filteredCountries.reduce<
    Record<string, typeof filteredCountries>
  >((acc, country) => {
    if (!acc[country.region]) {
      acc[country.region] = [];
    }
    acc[country.region].push(country);
    return acc;
  }, {});

  const handleSelect = (selectedCountryId: string) => {
    const selectedCountry = filteredCountries.find(
      (c) => c.id === selectedCountryId
    );
    if (!selectedCountry) return;

    const selectedRegion = selectedCountry.region;
    const selectedRegions = new Set(
      value
        .map((id) => filteredCountries.find((c) => c.id === id)?.region)
        .filter(Boolean)
    );

    let newValue: string[];

    if (selectedRegions.size > 0 && !selectedRegions.has(selectedRegion)) {
      newValue = [selectedCountryId];
    } else {
      if (value.includes(selectedCountryId)) {
        newValue = value.filter((v) => v !== selectedCountryId);
      } else {
        newValue = [...value, selectedCountryId];
      }
    }

    const validIds = newValue.filter((id) =>
      filteredCountries.some((c) => c.id === id)
    );

    onChange?.(validIds);
  };

  return (
    <Space direction="vertical" size="large" style={{ width: '100%' }}>
      {ALLOWED_REGIONS.filter((region) => groupedCountries[region]).map(
        (region) => (
          <div key={region}>
            <Title level={5}>{t(region)}</Title>
            <Space wrap>
              {groupedCountries[region].filter(Boolean).map((country) => (
                <CheckableTag
                  key={country.id}
                  checked={value.includes(country.id)}
                  onChange={() => handleSelect(country.id)}
                >
                  {country?.name ? t(country.name) : ''}
                </CheckableTag>
              ))}
            </Space>
          </div>
        )
      )}
    </Space>
  );
};
